export const initialValues = {
  name: '',
  email: '',
  cpf_or_rg: '',
  phone: '',
  birth_date: '',
  role: 'organizer', // Força organizador
  password: '',
};
export const USER_ROLES = [
  
  { value: 'organizer', label: 'organizer' },
];